import { FC, ReactNode } from 'react'
import SimpleBar from 'simplebar-react'
import clsx from 'clsx'

import 'simplebar-react/dist/simplebar.min.css'
import style from './scroll-area.module.scss'

interface IScrollArea {
  children: ReactNode
  customRef?: ReactNode
  simplebarRef?: any
  modificator?: string
  isGreyScrollbar?: boolean
  isNarrowScrollbar?: boolean
}

const ScrollArea: FC<IScrollArea> = ({
  children,
  customRef,
  simplebarRef,
  modificator = '',
  isGreyScrollbar,
  isNarrowScrollbar
}) => {
  return (
    <SimpleBar
      scrollableNodeProps={{ ref: customRef }}
      style={{ maxHeight: '100%' }}
      autoHide={false}
      ref={simplebarRef}
      className={clsx(style.scrollArea, {
        [modificator]: modificator,
        [style.greyScrollbar]: isGreyScrollbar,
        [style.narrowScrollbar]: isNarrowScrollbar
      })}
    >
      {children}
    </SimpleBar>
  )
}

export default ScrollArea
